import { createAction, props } from '@ngrx/store';
import { User } from '../models/user.model';
import { IdentificarRequest, IdentificarResponse, LoginResponse } from '../models/auth.model';
import { Administradora } from '../models/administradora-parametro.model';

// Tenant / Administradora (boot, ver TenantResolver + effects.ts)
export const setTenantSlug = createAction(
  '[Tenant] Set Tenant Slug',
  props<{ tenantSlug: string }>()
);

export const loadAdministradoraAttempt = createAction(
  '[Administradora] Load Attempt',
  props<{ tenantSlug: string }>()
);

export const loadAdministradoraSuccess = createAction(
  '[Administradora] Load Success',
  props<{ administradora: Administradora | null }>()
);

export const loadAdministradoraError = createAction(
  '[Administradora] Load Error',
  props<{ error: string }>()
);

// Autenticação — passo 1 (identificação, endpoint confirmado
// `PossuiSenhaExterna`). Ver core/models/auth.model.ts.
export const identificarAttempt = createAction(
  '[Auth] Identificar Attempt',
  props<{ request: IdentificarRequest }>()
);

export const identificarSuccess = createAction(
  '[Auth] Identificar Success',
  props<{ response: IdentificarResponse; tokenSessaoLogin: string }>()
);

export const identificarError = createAction(
  '[Auth] Identificar Error',
  props<{ error: string }>()
);

// Autenticação — passo 2 (senha, endpoint confirmado `LoginExterno`),
// CONFIRMADO como uma etapa dentro da MESMA URL `/{tenant}/` do passo 1 (ver
// LoginEtapa em core/store/state.ts), não uma rota separada.
export const loginAttempt = createAction(
  '[Auth] Login Attempt',
  props<{ senha: string }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ response: LoginResponse }>()
);

export const loginError = createAction('[Auth] Login Error', props<{ error: string }>());

export const voltarIdentificacao = createAction('[Auth] Voltar Identificacao');

// Mantida para quando o contrato real de `LoginExterno` for confirmado (ver
// `loginSuccess$` em core/store/effects.ts) — segue o mesmo padrão de
// `setAuthData` do ARQUITETURA.md do portal-cliente-frontend.
export const setAuthData = createAction(
  '[Auth] Set Auth Data',
  props<{ user: User; token: string }>()
);

export const signOut = createAction('[Auth] Sign Out');

// Layout
export const toggleSidenav = createAction('[Layout] Toggle Sidenav');

export const setSidenavOpened = createAction(
  '[Layout] Set Sidenav Opened',
  props<{ opened: boolean }>()
);
